import { AfterViewInit, ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { TableComponent } from '../../../components/table/table.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { tableModel } from '../../../components/table/model/tableModel';
import { AlertaService } from '../../../services/alerta.service';
import { Router } from '@angular/router';
import { FilterWithholdingGroup } from '../../../models/filters/filter-withholdings-group';
import { WithholdingGroupService } from '../../../services/withholding-group.service';

@Component({
  selector: 'app-withholdings',
  standalone: false,
  templateUrl: './withholdings.component.html',
  styleUrl: './withholdings.component.css'
})
export class WithholdingsComponent  implements AfterViewInit {

  ngAfterViewInit(): void {
    throw new Error('Method not implemented.');
  }

  @ViewChild(TableComponent) withholdingsTable:TableComponent| undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'#',columnValue:'id'},
      {columnName:'Descripción',columnValue:'description'}
    ],
    dataSource:[],
    editButton:true
  };

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterWithholdingGroup: FilterWithholdingGroup = new FilterWithholdingGroup;
  advancedSearch: boolean = false;
  
  private withholdingGroupService = inject(WithholdingGroupService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngOnInit(): void {
    this.filterWithholdingGroup = new FilterWithholdingGroup();
    this.searchWithholdingGroupPaginator();
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchWithholdingGroupPaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/withholdingsGroup/edit', event.id]);
  }
  addNewWithholdingGroup(){
    this.router.navigate(['/withholdingsGroup/edit', 0]);
  }

  searchWithholdingGroupPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchWithholdingGroupPaginator();
  }

  searchWithholdingGroupPaginator(){
    this.loading = true;

    this.withholdingGroupService.findAllPageableWithholdingGroup(this.filterWithholdingGroup, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.withholdingsTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }
}
